import { FilterConditionOutput } from '@shared/components/ui/AdvancedFilter';
import { FiltersDropdown } from '@shared/components/ui/FiltersDropdown';
import { useQueryParams } from '@shared/hooks/useQueryParams';
import { useCallback, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { RelocationsFiltersPanel } from './RelocationsFiltersPanel';

interface RelocationsFiltersSectionProps {
  onFilterChange?: (conditions: FilterConditionOutput[]) => void;
}

export const RelocationsFiltersSection = ({ onFilterChange }: RelocationsFiltersSectionProps) => {
  const { t } = useTranslation('relocationsModule');

  const { params, updateParam } = useQueryParams({
    filters: { type: 'json', default: [] as FilterConditionOutput[] },
  });

  const filtersFromUrl = useMemo(() => (Array.isArray(params.filters) ? params.filters : []), [params.filters]);

  const activeFiltersCount = useMemo(() => filtersFromUrl.length, [filtersFromUrl.length]);

  useEffect(() => {
    onFilterChange?.(filtersFromUrl);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtersFromUrl]);

  const handleFilterChange = useCallback(
    (conditions: FilterConditionOutput[]) => {
      updateParam('filters', conditions);
      onFilterChange?.(conditions);
    },
    [updateParam, onFilterChange],
  );

  return (
    <>
      {/* Panel de filtros (status, cart_id, fechas) — Relocations filters panel */}
      <FiltersDropdown
        title={t('filters.title')}
        activeFiltersCount={activeFiltersCount}
        triggerTestId="relocations-filters-toggle"
      >
        <RelocationsFiltersPanel initialConditions={filtersFromUrl} onChange={handleFilterChange} />
      </FiltersDropdown>
    </>
  );
};
